
import React from "react";
import {
  Button,
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../components/Global/OrderColumn";
import AddDesignBank from "./AddDesignBank";
import useDesignBank from "./useDesignBank";
import Select from "react-select";
import { Table } from "../../Global/Table";
const DesignBank = () => {
  const {
    queryState,
    showEditModal,
    tableFields,
    queryList,
    isLoading,
    isFetching,
    paginationOptions,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    handleSupplierFilter,
    handleItemTypeFilter,
    handleClearClick,
    handlePageSize,
    refetch,
    basicData,
  } = useDesignBank();
console.log(queryList?.data?.create_permission,"queryList")
  return (
    <div>
      <HeadingGroup
        title={"Design Bank"}
        className={`pro-mb-4`}
        // buttonTitle={queryList?.data?.create_permission ? "Add new" : ""}
        buttonTitle={queryList?.data?.create_permission && "Add new"}
        handleClick={handleModalClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="row gx-2 gy-2 pro-items-end">
          <div className="col-3">
            <SearchFilters
              onSearchInput={handleSearch}
              showActions={false}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              showClearFilters
              handleClear={handleClearClick}
              searchInputProps={{ value: queryState?.search , placeholder: "Search Design Id"  }}
            />
          </div>
          <div className="col-3">
            <div className="input-wrap">
              <label htmlFor="supplier" className="pro-font-sm pro-mb-1 pro-fw-medium">Supplier</label>
              <Select
                id="supplier"
                placeholder="Select Supplier"
                className="pro-input lg"
                classNamePrefix="pro-input"
                options={basicData?.suppliers ?? []}
                getOptionLabel={(option) => option?.name}
                getOptionValue={(option) => option?._id}
                value={basicData?.suppliers?.find(s => s._id === queryState?.supplier_id) || ""}
                onChange={(selected) => handleSupplierFilter(selected?._id || "")}
                menuPlacement="auto"
              />
            </div>
          </div>
          <div className="col-3">
            <div className="input-wrap">
              <label htmlFor="item_id" className="pro-font-sm pro-mb-1 pro-fw-medium">Item</label>
              <Select
                id="item_id"
                placeholder="Select Item"
                className="pro-input lg"
                classNamePrefix="pro-input"
                options={basicData?.item_types ?? basicData?.items ?? []}
                getOptionLabel={(option) => option?.name}
                getOptionValue={(option) => option?._id}
                value={(basicData?.item_types ?? basicData?.items ?? [])?.find(i => i._id === queryState?.item_id) || ""}
                onChange={(selected) => handleItemTypeFilter(selected?._id || "")}
                menuPlacement="auto"
              />
            </div>
          </div>
        </div>
        <Table
          multiSelect={false}
          data={queryList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          clear={queryState.clearSelection}
          perpage={queryState?.currentPageSize}
          assignable={false}
          handleEdit={handleEditAction}
          handleDelete={handleDeleteModal}
          deletable={queryList?.data?.delete_permission}
          editable={queryList?.data?.edit_permission}
          showCheckBox={true}
        />
        {queryList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={queryState?.currentPage}
            totalPageCount={Math.ceil(
              queryList.data.total_count / queryState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={queryState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected item?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={queryState?.showAddModal}
          handleClose={handleModalClick}
          title={queryState?.isEdit ? "Update Design Bank" : "Add Design Bank"}
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddDesignBank refetch={refetch} />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default DesignBank;
